"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extractData = extractData;
exports.extractEditorStateData = extractEditorStateData;
exports.extractSelectionStateData = extractSelectionStateData;
exports.extractContentStateData = extractContentStateData;
exports.extractContentBlockData = extractContentBlockData;
exports.forceSelectionAppend = forceSelectionAppend;
exports.forceSelectionToLast = forceSelectionToLast;
exports.getSelectedText = getSelectedText;
exports.insertTextModifier = insertTextModifier;
exports.replaceTextModifier = replaceTextModifier;
exports.createLinkEntityKey = createLinkEntityKey;
exports.CONTENT_BLOCK_DATA_MAP = exports.CONTENT_STATE_DATA_MAP = exports.SELECTION_STATE_DATA_MAP = exports.EDITOR_STATE_DATA_MAP = void 0;

var _draftJs = require("draft-js");

var _types = require("./types");

var EDITOR_STATE_DATA_MAP = {
  content: function content(editorState) {
    return editorState.getCurrentContent();
  },
  selection: function selection(editorState) {
    return editorState.getSelection();
  },
  style: function style(editorState) {
    return editorState.getCurrentInlineStyle();
  },
  block: function block(editorState) {
    return editorState.getBlockTree();
  }
};
exports.EDITOR_STATE_DATA_MAP = EDITOR_STATE_DATA_MAP;
var SELECTION_STATE_DATA_MAP = {
  startKey: function startKey(selectionState) {
    return selectionState.getStartKey();
  },
  startOffset: function startOffset(selectionState) {
    return selectionState.getStartOffset();
  },
  endKey: function endKey(selectionState) {
    return selectionState.getEndKey();
  },
  endOffset: function endOffset(selectionState) {
    return selectionState.getEndOffset();
  },
  anchorKey: function anchorKey(selectionState) {
    return selectionState.getAnchorKey();
  },
  anchorOffset: function anchorOffset(selectionState) {
    return selectionState.getAnchorOffset();
  },
  focusKey: function focusKey(selectionState) {
    return selectionState.getFocusKey();
  },
  focusKeyOffset: function focusKeyOffset(selectionState) {
    return selectionState.getFocusOffset();
  },
  isBackward: function isBackward(selectionState) {
    return selectionState.getIsBackward();
  },
  hasFocus: function hasFocus(selectionState) {
    return selectionState.getHasFocus();
  },
  isCollapsed: function isCollapsed(selectionState) {
    return selectionState.isCollapsed();
  },
  hasEdgeWithin: function hasEdgeWithin(selectionState) {
    return selectionState.hasEdgeWithin();
  },
  serial: function serial(selectionState) {
    return selectionState.serialize();
  }
};
exports.SELECTION_STATE_DATA_MAP = SELECTION_STATE_DATA_MAP;
var CONTENT_STATE_DATA_MAP = {
  entityMap: function entityMap(contentState) {
    return contentState.getEntityMap();
  },
  blockMap: function blockMap(contentState) {
    return contentState.getBlockMap();
  },
  selectionBefore: function selectionBefore(contentState) {
    return contentState.getSelectionBefore();
  },
  selectionAfter: function selectionAfter(contentState) {
    return contentState.getSelectionAfter();
  },
  blockForKey: function blockForKey(contentState) {
    var getBlockForKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    return contentState.getBlockForKey(getBlockForKey);
  },
  keyBefore: function keyBefore(contentState) {
    var getKeyBefore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    return contentState.getKeyBefore(getKeyBefore);
  },
  keyAfter: function keyAfter(contentState) {
    var getKeyAfter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    return contentState.getKeyAfter(getKeyAfter);
  },
  blockBefore: function blockBefore(contentState) {
    var getBlockBefore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    return contentState.getBlockBefore(getBlockBefore);
  },
  blockAfter: function blockAfter(contentState) {
    var getBlockAfter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    return contentState.getBlockAfter(getBlockAfter);
  },
  blocksArray: function blocksArray(contentState) {
    return contentState.getBlocksAsArray();
  },
  firstBlock: function firstBlock(contentState) {
    return contentState.getFirstBlock();
  },
  lastBlock: function lastBlock(contentState) {
    return contentState.getLastBlock();
  },
  plainText: function plainText(contentState) {
    var getPlainText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    return contentState.getPlainText(getPlainText);
  },
  lastCreatedEntityKey: function lastCreatedEntityKey(contentState) {
    return contentState.getLastCreatedEntityKey();
  },
  hasText: function hasText(contentState) {
    return contentState.hasText();
  },
  entity: function entity(contentState) {
    var getEntity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    return contentState.getEntity(getEntity);
  }
};
exports.CONTENT_STATE_DATA_MAP = CONTENT_STATE_DATA_MAP;
var CONTENT_BLOCK_DATA_MAP = {
  key: function key(contentBlock) {
    return contentBlock.getKey();
  },
  type: function type(contentBlock) {
    return contentBlock.getType();
  },
  text: function text(contentBlock) {
    return contentBlock.getText();
  },
  characterList: function characterList(contentBlock) {
    return contentBlock.getCharacterList();
  },
  length: function length(contentBlock) {
    return contentBlock.getLength();
  },
  depth: function depth(contentBlock) {
    return contentBlock.getDepth();
  },
  inlineStyle: function inlineStyle(contentBlock) {
    var getInlineStyleAt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    return contentBlock.getInlineStyleAt(getInlineStyleAt);
  },
  entity: function entity(contentBlock) {
    var getEntityAt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    return contentBlock.getEntityAt(getEntityAt);
  },
  data: function data(contentBlock) {
    return contentBlock.getData();
  }
}; // extractData helper function to extract data from draft.js api

exports.CONTENT_BLOCK_DATA_MAP = CONTENT_BLOCK_DATA_MAP;

function extractData(state, map) {
  var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return data.reduce(function (result, d) {
    var output = result;

    if ((0, _types.isObj)(d)) {
      var key = d.key,
          value = d.value;

      if (key) {
        var valueGetter = map[key];

        if (valueGetter) {
          output[key] = valueGetter(state, value);
        }
      }
    } else if (d) {
      var _valueGetter = map[d];

      if (_valueGetter) {
        output[d] = _valueGetter(state);
      }
    }

    return output;
  }, {});
} // extractEditorStateData helper function to extract data from editorState


function extractEditorStateData(editorState) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object.keys(EDITOR_STATE_DATA_MAP).map(function (key) {
    return {
      key: key
    };
  });
  return extractData(editorState, EDITOR_STATE_DATA_MAP, data);
} // extractSelectionStateData helper function to extract data from selectionState


function extractSelectionStateData(selectionState) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object.keys(SELECTION_STATE_DATA_MAP).map(function (key) {
    return {
      key: key
    };
  });
  return extractData(selectionState, SELECTION_STATE_DATA_MAP, data);
} // extractContentStateData helper function to extract data from contentState


function extractContentStateData(contentState) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object.keys(CONTENT_STATE_DATA_MAP).map(function (key) {
    return {
      key: key
    };
  });
  return extractData(contentState, CONTENT_STATE_DATA_MAP, data);
} // extractContentBlockData helper function to extract data from contentBlock


function extractContentBlockData(contentBlock) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object.keys(CONTENT_BLOCK_DATA_MAP).map(function (key) {
    return {
      key: key
    };
  });
  return extractData(contentBlock, CONTENT_BLOCK_DATA_MAP, data);
} // forceSelectionAppend returns editor state with forced selection to last character by n characters


function forceSelectionAppend(editorState) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var _extractEditorStateDa = extractEditorStateData(editorState, ['selection']),
      selection = _extractEditorStateDa.selection;

  var _extractSelectionStat = extractSelectionStateData(selection, ['endOffset', 'focusKey', 'anchorKey']),
      endOffset = _extractSelectionStat.endOffset,
      focusKey = _extractSelectionStat.focusKey,
      anchorKey = _extractSelectionStat.anchorKey;

  return _draftJs.EditorState.forceSelection(editorState, new _draftJs.SelectionState({
    anchorKey: anchorKey,
    anchorOffset: endOffset + length,
    focusKey: focusKey,
    focusOffset: endOffset + length
  }));
} // forceSelectionToLast returns editor state with forced selection to last character


function forceSelectionToLast(editorState) {
  return _draftJs.EditorState.moveFocusToEnd(editorState);
} // getSelectedText returns highlighted blocks as text


function getSelectedText(editorState) {
  var _extractEditorStateDa2 = extractEditorStateData(editorState, ['content', 'selection']),
      content = _extractEditorStateDa2.content,
      selection = _extractEditorStateDa2.selection;

  var _extractSelectionStat2 = extractSelectionStateData(selection, ['anchorKey', 'startOffset', 'endOffset']),
      anchorKey = _extractSelectionStat2.anchorKey,
      startOffset = _extractSelectionStat2.startOffset,
      endOffset = _extractSelectionStat2.endOffset;

  var _extractContentStateD = extractContentStateData(content, [{
    key: 'blockForKey',
    value: anchorKey
  }]),
      contentBlock = _extractContentStateD.blockForKey;

  return contentBlock.getText().slice(startOffset, endOffset);
} // insertTextModifier returns new content state with text inserted


function insertTextModifier(editorState, text) {
  var entity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var style = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var _extractEditorStateDa3 = extractEditorStateData(editorState, ['content', 'selection']),
      content = _extractEditorStateDa3.content,
      selection = _extractEditorStateDa3.selection; // insert text


  return _draftJs.Modifier.insertText(content, selection, text, style, entity);
} // replaceTextModifier returns new content state with text replaced


function replaceTextModifier(editorState, text) {
  var entity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var style = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var _extractEditorStateDa4 = extractEditorStateData(editorState, ['content', 'selection']),
      content = _extractEditorStateDa4.content,
      selection = _extractEditorStateDa4.selection; // replace text


  return _draftJs.Modifier.replaceText(content, selection, text, style, entity);
} // createLinkEntityKey returns entitykey of new content state with entity


function createLinkEntityKey(editorState) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    url: ''
  };

  var _extractEditorStateDa5 = extractEditorStateData(editorState, ['content']),
      content = _extractEditorStateDa5.content; // create link entity


  var contentWithLink = content.createEntity('LINK', 'MUTABLE', props);

  var _extractContentStateD2 = extractContentStateData(content, [{
    key: 'lastCreatedEntityKey',
    value: contentWithLink
  }]),
      lastCreatedEntityKey = _extractContentStateD2.lastCreatedEntityKey;

  return lastCreatedEntityKey;
}